import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';

import Icon, { faChevronDown, faChevronUp, faTriangleExclamation } from '~components/icon';
import { Column, TableView } from '~components/table-view-v3';

import { WarningItem } from '~support-at-home/actions/statements';

interface ComponentProps {
  id: string;
  title: string;
  warnings: WarningItem[];
  columns: Column[];
}

const WarningDetailsCard: React.FC<ComponentProps> = ({ id, title, warnings, columns }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card className="rounded-0 mb-2">
      <CardHeader
        className="d-flex justify-content-between border-0 fw-bold align-items-center"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>
          <Icon icon={faTriangleExclamation} className="text-warning me-2" />
          {title} ({warnings.length})
        </div>
        <Icon icon={isOpen ? faChevronUp : faChevronDown} className="ms-2" />
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody className="p-0">
          <TableView
            id={`${id}-warning-table`}
            columns={columns}
            data={warnings}
            emptyMessage="No warnings to display"
            readonly
            striped
          />
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default WarningDetailsCard;
